<div class="content dark">
	<h5>Operation datafiles</h5>
	<p>Views what datafiles were data sources for a particular operation.</p>
	<div class="form-group row">
		<div class="col-md-12">
			<select class="form-control form-control-sm op-list" [(ngModel)]="selectedOperation" (ngModelChange)="GetDatafiles()"
				title="Showing {{ assetOps && assetOps.length >= 800 ? 'latest 800' : 'all' }} operations">
				<option *ngFor="let operation of assetOps" [ngValue]="operation"
					[ngClass]="{ 'unacked-ex' : operation.exceedance_count > 0 && !operation.exceedance_ack_by, 'acked-ex': operation.exceedance_count > 0 && operation.exceedance_ack_by, 'no-ex': operation.exceedance_count === 0 }">
					{{operation.start_time | datetime : "offset" : asset.time_offset_hours}}{{operation.rotor_turn_time | runtime : " Rotor:"}}{{operation.flight_time | runtime :
					" Flight: "}}{{operation.exceedance_count > 0 ? " Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? " (ack)" : ""}}
				</option>
			</select>
			<table *ngIf="opDatafiles !== undefined && opDatafiles.length > 0" class="datafile-table">
				<tr>
					<th>Filename</th>
					<th>Import Date</th>
					<th>Size</th>
					<th>Status</th>
				</tr>
				<tr *ngFor="let datafile of opDatafiles">
					<td>{{datafile.filename}}</td>
					<td>{{datafile.imported | datetime : "offset" : asset.time_offset_hours}}</td>
					<td>{{datafile.size | filesize}}</td>
					<td>{{datafile.status}}</td>
				</tr>
			</table>
			<p *ngIf="opDatafiles !== undefined && opDatafiles.length === 0">No datafiles for this operation.</p>
		</div>
	</div>

	<hr class="my-4">
	<h5>Regenerate HI values</h5>
	<p>Recalculates all HI values from imported CI values using the current config.</p>
	<p>Note that regenerating HIs can take some time and will wipe out any history of alternate engine
		config. You should recalculate states (below) afterwards.</p>
	<div class="row my-3">
		<div class="col-sm-5">
			<app-action-button [action]="GenerateHIs" [context]="this" processing="Generating..." complete="HIs regenerated">Regenerate HI values</app-action-button>
		</div>
		<div class="col-sm-7">
			<p *ngIf="hiStatus">
				<ngb-progressbar type="success" [value]="hiProgress"></ngb-progressbar>
			</p>
			{{hiStatus}}
		</div>
	</div>

	<hr class="my-4">
	<h5>Recalculate component states</h5>
	<p>Deletes and recalculates states (normal, warning, alarm) for each component based on the most recent aquisitions.</p>
	<p>Recalculate component states when the underlying data has been changed but components are still in warning.</p>
	<div class="row my-3">
		<div class="col-sm-5">
			<app-action-button [action]="RecalculateStates" [context]="this" processing="Recalculating..." complete="States recalculated">Recalculate component states</app-action-button>
		</div>
		<div class="col-sm-7">
			<p *ngIf="statesStatus">
				<ngb-progressbar type="success" [value]="statesProgress"></ngb-progressbar>
			</p>
			{{statesStatus}}
		</div>
	</div>
</div>